import { OrderRejectionReason } from '../../../../../../../services/exports/Constants';

export default {
  statuses: {
    rejected: 'Cancelada: {{reason}}',
    fulfilled: 'Esta encomenda foi concluída com sucesso',
  },
  rejection_reasons: {
    [OrderRejectionReason.Automatic]: 'Não aceite',
    [OrderRejectionReason.ClosingSoon]: 'A fechar em breve',
    [OrderRejectionReason.ItemUnavailable]: 'Artigo indisponível',
    [OrderRejectionReason.OrderTooBig]: 'Encomenda demasiado grande',
    [OrderRejectionReason.CustomerMistake]: 'Erro do cliente',
    [OrderRejectionReason.Other]: 'Outro',
    fully_refunded: 'Encomenda foi totalmente reembolsada',
  },
};
